import { useEffect, useRef } from "react";
import { CallsTrend } from "../models/CallsAnalytics";

export default function CallVolumeChart({ trend }: { trend?: CallsTrend }) {

    const ref = useRef<HTMLDivElement>(null);
    const chartRef = useRef<any>(null);

    useEffect(() => {
        if (!trend || !ref.current) return;
        const Apex = (window as any).ApexCharts;
        const KTUtil = (window as any).KTUtil;
        if (!Apex || !KTUtil) return;

        const labelColor = KTUtil.getCssVariableValue("--bs-gray-500");
        const borderColor = KTUtil.getCssVariableValue("--bs-gray-200");
        const primary = KTUtil.getCssVariableValue("--bs-primary");
        const success = KTUtil.getCssVariableValue("--bs-success");
        const danger = KTUtil.getCssVariableValue("--bs-danger");

        const options = {
            series: [
                { name: "Inbound", data: trend.inbound },
                { name: "Outbound", data: trend.outbound },
                { name: "Missed", data: trend.missed },
            ],
            chart: { type: "area", height: 300, fontFamily: "inherit", toolbar: { show: false } },
            dataLabels: { enabled: false },
            stroke: { curve: "smooth", width: 2 },
            fill: { type: "gradient", gradient: { opacityFrom: 0.25, opacityTo: 0.03 } },
            legend: { show: true, position: "top", horizontalAlign: "left", fontSize: "12px" },
            markers: { size: trend.labels.length <= 12 ? 4 : 0, strokeWidth: 2 },
            xaxis: {
                categories: trend.labels,
                axisBorder: { show: false },
                axisTicks: { show: false },
                tickAmount: trend.labels.length > 14 ? 12 : undefined,
                labels: { rotate: -45, rotateAlways: trend.labels.length > 12, style: { colors: labelColor, fontSize: "11px" } }
            },
            yaxis: { min: 0, forceNiceScale: true, labels: { style: { colors: labelColor, fontSize: "12px" } } },
            colors: [success, primary, danger],
            grid: { borderColor, strokeDashArray: 4 },
            tooltip: { style: { fontSize: "12px" } }
        };

        if (chartRef.current) { try { chartRef.current.destroy(); } catch { } }
        chartRef.current = new Apex(ref.current, options);
        chartRef.current.render();

        return () => {
            if (chartRef.current) { try { chartRef.current.destroy(); } catch { } chartRef.current = null; }
        };
    }, [trend]);

    return <div ref={ref} style={{ minHeight: 300 }} />;
}
